'use strict';

var HTTPService = require('./http-service');

var CartService = {
  add: function add(sku, deliveredPhysicalStore, seller) {
    var pageName = (blz.pageName || '').toUpperCase();
    var url = '/api/carts/my/items?multi=true&html=true&partial=cart-summary&pageName=' + pageName;
    var item = _createCartItem(sku, deliveredPhysicalStore, seller);

    return HTTPService.post(url, item);
  },
  oneClick: function oneClick(sku, shippingAddress, seller) {
    var url = '/api/carts/one-click';
    var item = _createCartItem(sku, null, seller);

    return HTTPService.post(url, {
      items: item,
      shippingAddress: shippingAddress
    });
  }
};

function _createCartItem(sku, deliveredPhysicalStore, seller) {
  var items = [].concat(sku || []);

  return items.filter(Boolean).map(function (item) {
    var sellerInfo = item.seller || seller;
    if (!(sellerInfo || {}).id) {
      sellerInfo = null;
    }
    var sku = item.sku || item;

    return {
      quantity: 1,
      deliveredPhysicalStore: deliveredPhysicalStore || null,
      product: {
        sku: sku
      },
      seller: sellerInfo
    };
  });
}

module.exports = CartService;
